import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, Box, Button, Divider, IconButton, Popover, Stack, Typography } from '@mui/material';
import { brightRedBadgeSx } from 'components/common/badge/bright-red-badge';
import { useNotifications } from 'hooks/use-notifications';
import { FC, useMemo, useState } from 'react';
import { NotificationList } from './notification-list';

const ALL_FILTER = 'all';

export const NotificationBell: FC = () => {
  const { items, unreadCount, markRead, markAllRead } = useNotifications();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [filter, setFilter] = useState<string>(ALL_FILTER);
  const open = Boolean(anchorEl);

  const filteredItems = useMemo(
    () => (filter === ALL_FILTER ? items : items.filter((n) => n.refType === filter)),
    [items, filter],
  );
  const visibleUnreadCount = useMemo(
    () => filteredItems.filter((n) => !n.read).length,
    [filteredItems],
  );

  const handleMarkAllRead = () => {
    markAllRead(filter === ALL_FILTER ? undefined : filter);
  };

  return (
    <>
      <IconButton
        size="large"
        edge="start"
        color="inherit"
        aria-label="notifications"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge badgeContent={unreadCount} sx={brightRedBadgeSx}>
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { width: 380, maxHeight: 480 } } }}
      >
        <Box>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ px: 2, py: 1 }}
          >
            <Typography variant="subtitle1" fontWeight={700}>
              Notifications
            </Typography>
            <Button
              size="small"
              onClick={handleMarkAllRead}
              disabled={visibleUnreadCount === 0}
              sx={{ textTransform: 'none' }}
            >
              Mark all read
            </Button>
          </Stack>
          <Divider />
          <NotificationList
            items={items}
            filteredItems={filteredItems}
            filter={filter}
            onFilterChange={setFilter}
            onItemClick={(id) => {
              markRead(id);
              setAnchorEl(null);
            }}
          />
        </Box>
      </Popover>
    </>
  );
};
